import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from '../assets//guidelines.png'
import _imports_1 from '../assets/invalidate.png'
import _imports_2 from '../assets/alert.png'


const _hoisted_1 = {
  class: "relative-container",
  ref: "rootEl"
}
const _hoisted_2 = { class: "labels-header" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["for"]
const _hoisted_6 = ["id", "name", "data-line-id", "readonly", "onUpdate:modelValue", "onClick", "onInput", "onKeyup", "onFocus", "onBlur"]
const _hoisted_7 = { class: "label-actions" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["title", "onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 3,
  class: "label-wrong-wrap"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 0,
  class: "solve-menu",
  role: "menu"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 1,
  class: "icon-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: _normalizeClass(["labels-buttons", { 'disabled-image': !_ctx.projectImageReady }]),
        src: _imports_0,
        alt: "upload",
        title: "Project Guidelines",
        onMouseenter: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onEnterPreview && _ctx.onEnterPreview(...args))),
        onMousemove: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updatePopupPosition && _ctx.updatePopupPosition(...args))),
        onMouseleave: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onLeavePreview && _ctx.onLeavePreview(...args)))
      }, null, 34),
      (_ctx.showPreview && _ctx.projectImageReady)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "image-preview-popup",
            style: _normalizeStyle({ top: _ctx.popupPosition.top + 'px', left: _ctx.popupPosition.left + 'px' })
          }, [
            _createElementVNode("img", {
              src: _ctx.projectImageUrl,
              class: "image-preview",
              alt: "Project Preview",
              style: _normalizeStyle({ width: _ctx.originalImageSize.width + 'px', height: _ctx.originalImageSize.height + 'px' })
            }, null, 12, _hoisted_3)
          ], 4))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["labels-content", { empty: _ctx.lines.length === 0 }])
    }, [
      (_ctx.lines.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lines, (line, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: line.id,
                class: "label-row"
              }, [
                _createElementVNode("label", {
                  class: "sr-only",
                  for: `label-${line.id}`
                }, "Label for line " + _toDisplayString(index + 1), 9, _hoisted_5),
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["item-input", { 'label-hidden': line.is_hidden }]),
                  id: `label-${line.id}`,
                  name: `label-${line.id}`,
                  "data-line-id": line.id,
                  readonly: _ctx.readOnly,
                  type: "text",
                  "onUpdate:modelValue": ($event: any) => ((line.label) = $event),
                  onClick: ($event: any) => (_ctx.onFocus(line)),
                  onInput: ($event: any) => (!_ctx.readOnly && _ctx.onInput(line)),
                  onKeyup: [
                    _withKeys(_withModifiers(($event: any) => (!_ctx.readOnly && _ctx.onEnter(line, index)), ["prevent"]), ["enter"]),
                    _withKeys(($event: any) => (!_ctx.readOnly && _ctx.onEsc($event, line)), ["esc"])
                  ],
                  onFocus: ($event: any) => (_ctx.onFocus(line)),
                  onBlur: ($event: any) => (_ctx.onBlur(line))
                }, null, 42, _hoisted_6), [
                  [_vModelText, line.label]
                ]),
                _createElementVNode("div", _hoisted_7, [
                  (_ctx.isEditorMode && !_ctx.readOnly && _ctx.focusedId === line.id)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "label-trash",
                        title: "Delete label",
                        onMousedown: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
                        onClick: _withModifiers(($event: any) => (_ctx.onDelete(line)), ["stop"]),
                        "aria-label": "Delete label",
                        tabindex: "-1"
                      }, [
                        _createVNode(_component_font_awesome_icon, { icon: "trash-can" })
                      ], 40, _hoisted_8))
                    : _createCommentVNode("", true),
                  (_ctx.isEditorMode && _ctx.focusedId === line.id)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "label-eye",
                        title: line.is_hidden ? 'Show' : 'Hide',
                        onMousedown: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
                        onClick: _withModifiers(($event: any) => (_ctx.toggleHidden(line)), ["stop"]),
                        "aria-label": "Toggle visibility",
                        tabindex: "-1"
                      }, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: line.is_hidden ? 'eye-slash' : 'eye'
                        }, null, 8, ["icon"])
                      ], 40, _hoisted_9))
                    : _createCommentVNode("", true),
                  (_ctx.isReviewMode)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        type: "button",
                        class: _normalizeClass(["label-action-btn", { active: _ctx.wrongIdsSet.has(line.id) }]),
                        title: "Tag as Wrong",
                        onClick: _withModifiers(($event: any) => (_ctx.$emit('markWrong', line)), ["stop"]),
                        "aria-label": "Tag Wrong",
                        tabindex: "-1"
                      }, _cache[5] || (_cache[5] = [
                        _createElementVNode("img", {
                          src: _imports_1,
                          alt: ""
                        }, null, -1)
                      ]), 10, _hoisted_10))
                    : (_ctx.isEditorMode && line.review_wrong)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createElementVNode("img", {
                            class: "wrong-icon",
                            src: _imports_2,
                            alt: "",
                            title: "Line was considered wrong",
                            onClick: _withModifiers(($event: any) => (_ctx.openSolveMenu(line)), ["stop"])
                          }, null, 8, _hoisted_12),
                          (_ctx.solveMenuFor === line.id)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _createElementVNode("button", {
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.solve(line)),
                                  style: {"color":"white"}
                                }, "Solved", 8, _hoisted_14)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_15, _cache[6] || (_cache[6] = [
            _createElementVNode("div", { class: "icon-text-container" }, [
              _createElementVNode("span", null, "No Labels")
            ], -1)
          ])))
    ], 2)
  ], 512))
}